import { z } from "zod";

/**
 * Zod schemas for Authentication forms
 * Messages use translation keys
 */

export const loginSchema = z.object({
    email: z.string()
        .min(1, "errors.emailRequired")
        .email("errors.invalidEmail"),
    password: z.string()
        .min(1, "errors.passwordRequired"),
});

export const registerSchema = z
    .object({
        email: z.string()
            .min(1, "errors.emailRequired")
            .email("errors.invalidEmail"),
        password: z
            .string()
            .min(8, "errors.passwordMinLength")
            .regex(/[A-Z]/, "errors.passwordUppercase")
            .regex(/[a-z]/, "errors.passwordLowercase")
            .regex(/[0-9]/, "errors.passwordNumber"),
        confirmPassword: z.string().min(1, "errors.confirmPasswordRequired"),
    })
    .refine((data) => data.password === data.confirmPassword, {
        message: "errors.passwordsDontMatch",
        path: ["confirmPassword"],
    });
